module.exports = __webpack_public_path__ + "static/media/SectionGeometry.4c923193.svg";